import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { UserRegistrationModal } from './userRegistration/userRegistrationModal';
import { BusinessRegistrationModal } from './businessRegistration/BusinessRegistrationModal';
import { useState } from 'react';
import { User, Building2 } from 'lucide-react';

interface RegistrationChoiceProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RegistrationChoice({ isOpen, onClose }: RegistrationChoiceProps) {
  const [showUserModal, setShowUserModal] = useState(false);
  const [showBusinessModal, setShowBusinessModal] = useState(false);

  return (
    <>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="sm:max-w-[400px] p-6">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-center">
              Choose Registration Type
            </DialogTitle>
          </DialogHeader>
          
          <div className="flex flex-col gap-4 mt-4">
            <Button 
              onClick={() => {
                onClose();
                setShowUserModal(true);
              }}
              className="flex items-center gap-2 bg-[#77A146] hover:bg-[#619A46]"
            >
              <User className="h-5 w-5" />
              Register as Traveler
            </Button>
            <Button 
              onClick={() => {
                onClose();
                setShowBusinessModal(true);
              }}
              className="flex items-center gap-2 bg-primary hover:bg-[#1A4A1B]"
            >
              <Building2 className="h-5 w-5" />
              Register as Business
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <UserRegistrationModal 
        isOpen={showUserModal} 
        onClose={() => setShowUserModal(false)} 
      />
      <BusinessRegistrationModal 
        isOpen={showBusinessModal} 
        onClose={() => setShowBusinessModal(false)} 
      />
    </>
  );
}